import { I18N_LOCALE_TOGGLE } from '@core/app-config';
import { toLocaleFromPath } from '@core/internationalize/models/locale';
import { HOMESCREEN_ROUTE } from './homescreen';
import {
  WELCOME_PATH,
  PASSWORD_PATH,
  USERNAME_PATH,
  BIRTHDATE_PATH,
  LOCATION_PATH,
  PROFILE_IMAGE_PATH,
  COLLECT_PRODUCT_INTEREST_PATH,
  DOWNLOAD_APP_PATH_PREFIX,
  BENEFITS_WELCOME_PATH,
  QUIZ_PATH,
  PREFERENCES_PATH,
} from './profile-setup';

const KEY = 'members/attemptedRoute';

// don't allow some paths to be returned
// in order to prevent infinite loop
const disallowedPaths = [
  WELCOME_PATH,
  PASSWORD_PATH,
  USERNAME_PATH,
  BIRTHDATE_PATH,
  LOCATION_PATH,
  PROFILE_IMAGE_PATH,
  COLLECT_PRODUCT_INTEREST_PATH,
  DOWNLOAD_APP_PATH_PREFIX,
  BENEFITS_WELCOME_PATH,
  QUIZ_PATH,
  PREFERENCES_PATH,
];

// using sessionStorage because this is not needed to persist longer than a single window session
export const persistAttemptedRoute = () => {
  if (!!window) {
    let pathname = window.location.pathname;
    if (I18N_LOCALE_TOGGLE) {
      const locale = toLocaleFromPath(pathname);
      if (locale) {
        pathname = pathname.slice(`/${locale}`.length) || '/';
      }
    }

    const isDisallowed = disallowedPaths.some(p =>
      p === DOWNLOAD_APP_PATH_PREFIX ? pathname.startsWith(p) : pathname === p,
    );

    if (!isDisallowed) {
      const attemptedRoute = `${pathname}${window.location.search}`;
      window.sessionStorage.setItem(KEY, attemptedRoute);
    }
  }
};

// this function will return the persisted route
// if no persisted route, use the provided default or go to home screen
export const getPersistedAttemptedRoute = (defaultRoute?: string) => {
  if (!!window) {
    const persistedAttemptedRoute =
      window.sessionStorage.getItem(KEY) ?? defaultRoute ?? HOMESCREEN_ROUTE;

    return persistedAttemptedRoute;
  }

  return defaultRoute ?? HOMESCREEN_ROUTE;
};
